"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var app_1 = require("./app");
exports.default = (function (_a) {
    var skipSteps = _a.skipSteps;
    return (React.createElement(app_1.AppContext.Consumer, null, function (context) {
        if (!context) {
            return null;
        }
        var bundlerSteps = context.bundlerSteps, currentStepIdx = context.currentStepIdx, isEmailBeforeFreebieTest = context.isEmailBeforeFreebieTest;
        var startOver = function () { return React.createElement(react_router_dom_1.Redirect, { to: "/".concat(bundlerSteps[0]) }); };
        var shouldNotSkipStep = function (step) { return !skipSteps || !skipSteps.includes(step); };
        var isSelectSizeInvalid = function () { return shouldNotSkipStep('select-size') && !context.selMainVariant; };
        var isSelectPrintsInvalid = function () { return shouldNotSkipStep('select-prints') && context.selChoices.length < 1; };
        var isSelectAddOnsInvalid = function () { return (isEmailBeforeFreebieTest ? false : shouldNotSkipStep('select-add-ons') && context.selAddOns.length === 0); };
        var isSelectDiscountAddOnsInvalid = function () { return shouldNotSkipStep('select-discount-add-ons') && false; };
        var isSelectFrequencyInvalid = function () { return shouldNotSkipStep('select-frequency') && !context.selShippingFrequency; };
        switch (bundlerSteps[currentStepIdx]) {
            case 'select-prints':
                if (isSelectSizeInvalid()) {
                    return startOver();
                }
                break;
            case 'select-add-ons':
                if (isSelectSizeInvalid() || isSelectPrintsInvalid()) {
                    return startOver();
                }
                break;
            case 'select-discount-add-ons':
                if (isSelectSizeInvalid() || isSelectPrintsInvalid() || isSelectAddOnsInvalid()) {
                    return startOver();
                }
                break;
            case 'select-frequency':
                if (isSelectSizeInvalid() || isSelectPrintsInvalid() || isSelectAddOnsInvalid() || isSelectDiscountAddOnsInvalid()) {
                    return startOver();
                }
                break;
            case 'confirm':
                if (isSelectSizeInvalid() || isSelectPrintsInvalid() || isSelectAddOnsInvalid() || isSelectDiscountAddOnsInvalid() || isSelectFrequencyInvalid()) {
                    return startOver();
                }
                break;
        }
        return null;
    }));
});
